import { Routes } from "@angular/router";

export const staticPagesRoutes: Routes = [
  {
    path: "terms",
    loadComponent: () => import("./domains/terms/pages/terms/terms.component").then(c => c.TermsComponent),
  },
  {
    path: "privacy",
    loadComponent: () => import("./domains/privacy/pages/privacy/privacy.component").then(c => c.PrivacyComponent),
  },
];
